import React, { useEffect } from 'react'
import logo from "../../assets/img/HE-LogoB-200.png";
import logoFederpol from "../../assets/img/logo-federpol-he-testata.png";//NEW
import logoAiss from "../../assets/img/logo-aissl-he-testata.png";//NEW
import { matchPath, useLocation, useNavigate } from "react-router";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setLoggedUser } from '../../store/actions/user'; 
import { authRoutes } from '../../model/authRoutes';
import { sidebarRoutes } from '../../model/sidebarRoutes';
import { Dropdown } from 'react-bootstrap';
import { ROLES } from '../../model/roles';
import { setSidebarCollapse } from '../../store/actions/sidebarCollapse';
import useMediaQuery from '../../hooks/useMediaQuery';

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.user.userData?.sub);
  const location = useLocation();
  // const isAuthRoutes = authRoutes.includes(location.pathname);
  const isMax600px = useMediaQuery('(max-width: 600px)');
  const isTicketRoute = matchPath('/ticket/:idTicket', location.pathname);
  const isSidebarRoutes = sidebarRoutes.includes(location.pathname);
  const userLoggedIn = useSelector(state => state.user.userData);

  const handleLogout = () => {
    dispatch(setLoggedUser(null)); 
    navigate("/accedi");
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
  };

  const collapsedState = useSelector(state => state?.sidebarCollapse);

  const idSP = localStorage.getItem("idSP");//NEW
  var logoPut = logo;
  var widthLogo = '';
  var onclickNavigate = () => navigate("/corsi");
  if(idSP == 1){//Aiss
    logoPut = logoAiss;
    widthLogo = '400px';
    onclickNavigate = () => window.location.href = 'https://formazione.aissitalia.org/';
  }
  else if(idSP == 2){//Federpol
    logoPut = logoFederpol;
    widthLogo = '400px';
    onclickNavigate = () => window.location.href = 'https://stage.federpol.academy/';
  }
  ///////////////////////////////////////
  
  const toggleMenu = () => {
    dispatch(setSidebarCollapse(!collapsedState));
}

  return (
    <nav className={`${(isSidebarRoutes || isTicketRoute) && isAuthenticated ? 'bg-secondary' : 'bg-dark'} ${(!isSidebarRoutes && !isTicketRoute && isAuthenticated) ? 'bg-dark' : 'bg-secondary'} ${(!isSidebarRoutes && !isTicketRoute && !isAuthenticated) ? 'bg-dark' : 'bg-secondary'} navbar d-flex w-100  p-0`}>
      <div className="content-navbar p-3 container-fluid">
        <span role='button' className="navbar-brand ">
          {
            (isSidebarRoutes || isTicketRoute) && isAuthenticated ? '' : <img src={logoPut} width={widthLogo} alt="logo" onClick={onclickNavigate}/>//NEW
          }
            {
              (isSidebarRoutes || isTicketRoute) && isMax600px && (
                <i className="bi bi-list fs-5 text-dark" role='button' onClick={toggleMenu}></i>
              )
            }
        </span>
        <div className="text-light fs-4 d-flex navbar-link">
          <div className="d-flex">
              {isAuthenticated ? (
                <>
                  <Dropdown className='mx-1'>
                    <span className={`${(isSidebarRoutes || isTicketRoute) ? 'text-dark' : 'text-light'} fs-6 me-2`}>
                      {userLoggedIn?.nome} {userLoggedIn?.cognome} 
                    </span>
                  <Dropdown.Toggle variant={(isSidebarRoutes || isTicketRoute) ? 'dark' : 'light'} id="dropdown-basic">
                   <i className="bi bi-person" style={{borderRadius: "50%"}}></i>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigate("/profilo")}>Profilo</Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      if(userLoggedIn?.role === ROLES.CORSISTA) {
                         navigate("/area-personale/corsi")
                      } else if(userLoggedIn?.role === ROLES.PARTNER){
                         navigate("/gestione-utenti")
                      } else if(userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.DOCENTE) {
                         navigate("/gestione-corsi")
                      }  else if(userLoggedIn?.role === ROLES.TUTOR) {
                        navigate("/area-personale/classi")
                     }
                    }}>Area personale</Dropdown.Item>
                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
             
                {/* <button className={`btn ${isProfilePath ? 'btn-dark' : 'btn-light'} mx-1`} onClick={() => navigate("/profilo")}>Profilo <i className="bi bi-person"></i></button> */}
                {/* <button className={`btn ${isProfilePath ? 'btn-custom-logout' : 'btn-outline-light'}  mx-1`} onClick={handleLogout}>Logout <i className="bi bi-box-arrow-right"></i></button> */}
                </>
            ) : (
              <>
                <button className='btn btn-outline-light mx-1' onClick={() => navigate("/accedi")}>Accedi</button>
                <button className='btn btn-primary mx-1' onClick={() => navigate("/registrati")}>Registrati</button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar